import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IntegrationLogo from "components/IntegrationLogo";
import Typography from "@mui/material/Typography";
import Icon from "@mui/material/Icon";
import TooltipLight from "utils/TooltipLight";

function IntegrationCard({ connected, warningMessage, onClickCb, description, parentName }) {
  return (
    <Grid item xs={12} sm={10} md={6} lg={4} xl={4}>
      <Card
        sx={{
          padding: "1rem",
          borderRadius: "15px",
          "&:hover": {
            cursor: "pointer",
            boxShadow: "4px 3px 3px #9f9f9fb3",
          },
          height: "300px",
          position: "relative",
        }}
        onClick={onClickCb}
      >
        {warningMessage && (
          <Box sx={{ position: "absolute", right: "1rem", top: "1rem" }}>
            <TooltipLight title={warningMessage.tooltipMessage}>
              <Icon sx={{ color: "red" }}>{warningMessage.icon}</Icon>
            </TooltipLight>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <IntegrationLogo width="200px" height="100px" logo={parentName} />
        </Box>
        <Typography
          variant="p"
          sx={{
            margin: "1rem",
          }}
        >
          {description}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            bottom: ".5rem",
            right: ".5rem",
            position: "absolute",
          }}
        >
          {connected ? (
            <>
              <Typography sx={{ color: "green", paddingTop: "2px", marginRight: "8px" }}>
                Connected
              </Typography>
              <Icon sx={{ fontWeight: "bold", color: "green" }}>radio_button_checked</Icon>
            </>
          ) : (
            <>
              <Typography sx={{ color: "gray", paddingTop: "2px", marginRight: "8px" }}>
                Not Connected
              </Typography>
              <Icon sx={{ fontWeight: "bold", color: "gray" }}>radio_button_unchecked</Icon>
            </>
          )}
        </Box>
      </Card>
    </Grid>
  );
}

export default IntegrationCard;
